import type { Column, Filter } from '@/components/table/base'
import type { FilterParams } from '@/stores/tournaments/tournaments.store'
import type { GolfTournamentWithFeedCount } from '@/stores/tournaments/tournaments.utils'

export const TOURNAMENTS_TABLE_COLUMNS: Column<GolfTournamentWithFeedCount>[] = [
  {
    type: 'text',
    id: 'id',
    label: 'ID',
    sortAttribute: 'id'
  },
  {
    type: 'text',
    id: 'name',
    label: 'Name',
    sortAttribute: 'name'
  },
  {
    type: 'date',
    id: 'startDate',
    label: 'Start Date',
    sx: { whiteSpace: 'nowrap' },
    sortAttribute: 'startDate'
  },
  {
    type: 'date',
    id: 'endDate',
    label: 'End Date',
    sx: { whiteSpace: 'nowrap' },
    sortAttribute: 'endDate'
  },
  {
    type: 'text',
    id: 'mainGolfCourseName',
    label: 'Location',
    sortAttribute: 'mainGolfCourseName'
  },
  {
    type: 'text',
    id: 'utcOffset',
    label: 'UTC Offset',
    sortAttribute: 'utcOffset'
  },
  {
    type: 'text',
    id: 'count',
    label: 'In Memory',
    transform: (count) => (count?.matchByExternalId || count?.matchByInternalId ? 'Yes' : 'No'),
    sortAttribute: 'count'
  },
  {
    type: 'text',
    id: 'tournamentDataStatus',
    label: 'Tournament Data Status',
    sortAttribute: 'tournamentDataStatus'
  }
]

export const TOURNAMENTS_TABLE_FILTERS: Filter<GolfTournamentWithFeedCount, FilterParams>[] = [
  {
    type: 'date',
    roundTo: 'start',
    label: 'Start Date',
    paramName: 'dateFrom'
  },
  {
    type: 'date',
    roundTo: 'end',
    label: 'End Date',
    paramName: 'dateTo'
  }
]
